var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{class:_vm.linkClass,attrs:{"disabled":_vm.isCreating},on:{"click":_vm.createAssemblySheet}},[_vm._v(" "+_vm._s(this.linkText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }